import React from 'react'
import PropTypes from 'prop-types'
import Style from './style'
import { FLOORPLAN } from '../../../helpers'

class ImageDisplayComponent extends React.Component {
  render () {
    const props = Object.assign({}, this.props)
    if (props.src == null) {
      return (
        <Style>
          <p>
            {props.isShowing ? FLOORPLAN.NO_IMAGE[props.language] : FLOORPLAN.NO_BUILDING[props.language]}
          </p>
        </Style>
      )
    }
    return (
      <Style>
        <img
          id='floorLayoutImage'
          src={['data:image/png;base64', props.src].join(', ')}
          alt='Floor layout.'
        />
      </Style>
    )
  }
}

ImageDisplayComponent.propTypes = {
  src: PropTypes.string,
  isShowing: PropTypes.bool,
  language: PropTypes.string
}

export default ImageDisplayComponent
